import { API_URL} from './Constants';
import ApiService from './ApiService';

class HomePageApi {
  static getDataSlideShow = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/slide-show", params);
    } catch (error) {
    }
  };

  static getDataHeaderSlideShow = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/header-slide-show", params);
    } catch (error) {
    }
  };

  static getDataVideoMoiCapNhat = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/new-videos", params);
    } catch (error) {
    }
  };

  static getDataAudioMoiCapNhat = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/new-audios", params);
    } catch (error) {
    }
  };

  static getDataSachNoiMoiCapNhat = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/new-books-audios", params);
    } catch (error) {
    }
  };

  static getDataKinhVaAudioMoiCapNhat = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/nikaya-audio", params);
    } catch (error) {
    }
  };

  static getDataGuongSangTuHanh = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/guong-sang-tu-hanh", params);
    } catch (error) {
    }
  };

  static getDataGiangSu = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/giang-su", params);
    } catch (error) {
    }
  };

  static getDataTinTuc = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/tin-tuc-loi-phat-day", params);
    } catch (error) {
    }
  };

  static getDatathuVienKinhSach = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/thu-vien-kinh-sach", params);
    } catch (error) {
    }
  };

  static getDataNhacPhatGiao = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/nhac-phat-giao", params);
    } catch (error) {
    }
  };

  static getDataThongKe = async () => {
    try {
      const params = {}; // Example params to filter data
      return await ApiService.getDataWithParams(API_URL + "/home/thong-ke", params);
    } catch (error) {
    }
  };
}

export default HomePageApi;
